var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLoopVideo = function SvgIconLoopVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M3.445 10.418a5.2 5.2 0 0 1-.457-1.162 5 5 0 0 1-.155-1.223q0-2.163 1.506-3.681Q5.844 2.834 8 2.833h.52L7.288 1.6 7.99.897l2.436 2.436L7.99 5.77l-.703-.702 1.234-1.234H8q-1.738 0-2.953 1.223T3.833 8.033a3.9 3.9 0 0 0 .362 1.635zm4.566 4.685-2.436-2.436L8.01 10.23l.702.702-1.233 1.234H8q1.737 0 2.952-1.223t1.215-2.977a3.9 3.9 0 0 0-.362-1.635l.75-.75q.303.563.457 1.162.155.6.155 1.223 0 2.163-1.505 3.681T8 13.167h-.52L8.713 14.4z"
  })));
};
export default SvgIconLoopVideo;